module.exports = __webpack_public_path__ + "static/media/Iphone.b1bd9da8.PNG";